module.exports = __webpack_public_path__ + "static/media/SWSCRC6-1.bd6d2766.mp3";